import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, onBeforeMount } from 'vue'
import { useNow } from '@vueuse/core'
import { resolveTopBanner } from '@/utils/top/topBannerSchedule'
import TopContact from '@/components/top/TopContact.vue'
import TopFeatureStrip from '@/components/top/TopFeatureStrip.vue'
import TopFormatList from '@/components/top/TopFormatList.vue'
import TopKnowhowList from '@/components/top/TopKnowhowList.vue'
import TopNoticeBar from '@/components/top/TopNoticeBar.vue'
import TopServiceSteps from '@/components/top/TopServiceSteps.vue'
import ReferralInviteeBanner from '@/components/yagiprime/ReferralInviteeBanner.vue'

// MV バナーの週替わり。開きっぱなしのタブでも日付跨ぎで差し替わるよう毎時更新
type CookiesApi = {
  config: (expireTimes: number, path: string) => void
  set: (
    key: string,
    value: string,
    expire: null,
    path: null,
    domain: string
  ) => void
}
type GlobalVar = { googleAdsTagCheck: (a: string, b: string) => void }


export default /*#__PURE__*/_defineComponent({
  __name: 'Top',
  props: {
  /** /aff/:affId 経由の流入。アフィリエイト ID として Cookie に残す */
  affId: {
    type: String,
    default: ''
  },
  /** /oem/:oemId 経由の流入 */
  oemId: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props;

/**
 * トップページ。中身はすべて子コンポーネントで、この SFC が持つのは
 * 流入パラメータ（アフィリエイト / OEM）の Cookie 保存だけ。
 *
 * ⚠️ 静的トップ(public/top-content.html)はこの <template> から
 * scripts/extract-top-static.js が生成する。API 取得コンテンツは
 * <!-- static:skip --> で囲んで焼かれないようにすること。
 */
const now = useNow({ interval: 60 * 60 * 1000 })
const topBanner = computed(() => resolveTopBanner(now.value))

/** Cookie を配る対象ドメイン。localhost は開発用 */
const COOKIE_DOMAINS = ['yagish.jp', 'localhost']
const COOKIE_MAX_AGE_SEC = 60 * 60 * 24
/** OEM 経由の流入として受け付ける ID。ここに無い oemId は無視する */
const ALLOWED_OEM_IDS = ['kokudo-bl']



const vm = getCurrentInstance()!.proxy as unknown as {
  $cookies: CookiesApi
  $globalVar: GlobalVar
}

function setCookieOnAllDomains(key: string, value: string): void {
  vm.$cookies.config(COOKIE_MAX_AGE_SEC, '')
  for (const domain of COOKIE_DOMAINS) {
    vm.$cookies.set(key, value, null, null, domain)
  }
}

onBeforeMount(() => {
  vm.$globalVar.googleAdsTagCheck('', '')

  if (props.affId) {
    setCookieOnAllDomains('_YAGISH_AFFILIATE_ID', props.affId)
  }
  // OEM は OEM ID とアフィリエイト ID の両方に入れる（従来の挙動を維持）
  if (ALLOWED_OEM_IDS.indexOf(props.oemId) >= 0) {
    setCookieOnAllDomains('_YAGISH_OEM_ID', props.oemId)
    setCookieOnAllDomains('_YAGISH_AFFILIATE_ID', props.oemId)
  }
})

return { __sfc: true,now, topBanner, COOKIE_DOMAINS, COOKIE_MAX_AGE_SEC, ALLOWED_OEM_IDS, props, vm, setCookieOnAllDomains, TopContact, TopFeatureStrip, TopFormatList, TopKnowhowList, TopNoticeBar, TopServiceSteps, ReferralInviteeBanner }
}

})